import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { useAuthedUser } from '../../common/providers/AuthedUserProvider';
import { requestBuilder } from '../../http/RequestBuilder';
import { membershipGoalsAtom } from '../state/GoalAtoms';
import type { GetGoalsRequest } from '../types/GetGoalsRequest';
import type { IGoalGroup } from '../types/Goal';

const fetchGoals = requestBuilder.query<IGoalGroup[], GetGoalsRequest>({
    endpoint: ({ membershipId }) =>
        `/api/guidance/goals/groups?membershipId=${membershipId}`,
    queryKey: ({ membershipId }) => `getGoals/${membershipId}`,
});

const useGetGoals = (enabled = false, refetchOnWindowFocus = false) => {
    const user = useAuthedUser();
    const membershipId = user.membership?.id ?? '';

    const setMembershipGoals = useSetAtom(membershipGoalsAtom);

    const { data, isLoading, isRefetching, refetch } = fetchGoals(
        {
            membershipId,
        },
        { enabled, gcTime: 0, refetchOnWindowFocus },
    );

    useEffect(() => {
        if (!isLoading && data) {
            setMembershipGoals(data);
        }
    }, [data, isLoading]);

    return {
        data,
        isLoading,
        isRefetching,
        refetch,
    };
};

export default useGetGoals;
